<div id="app-message" class="montserrat" [class.sticky]="isSticky"></div>